import products from 'redux/middleware/analytics/actions-to-track/products-and-components/search-and-browse/search-and-browse-products';
import searchResults from './search-results';

export default state => [products(state), searchResults(state)];
